import { render, staticRenderFns } from "./Shifts.vue?vue&type=template&id=34cd0237&scoped=true"
import script from "./Shifts.vue?vue&type=script&lang=js"
export * from "./Shifts.vue?vue&type=script&lang=js"
import style0 from "./Shifts.vue?vue&type=style&index=0&id=34cd0237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cd0237",
  null
  
)

export default component.exports